import React, { useState } from 'react';
import Price from '../Price';
import LightButton from '../../button/LightButton';
import Percentage from '../Percentage';

export const PaymentSummaryItems = ({ items, toPay = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const [expandedStates, setExpandedStates] = useState(
    items.map(() => false), // lub false — zależnie od tego, czy domyślnie rozwinięte
  );

  return (
    <div className="">
      {/* Podsumowanie */}
      {items.map((item, index) => {
        if (item.amount == null || item.show === false) return null;

        const isExpanded = expandedStates[index];
        const toggleExpanded = () => {
          if (item.expandable) {
            setExpandedStates((prev) =>
              prev.map((val, i) => (i === index ? !val : val)),
            );
          }
        };

        return (
          <React.Fragment key={index}>
            <div
              onClick={toggleExpanded}
              style={{ cursor: item.expandable ? 'pointer' : 'default' }}
              className={`d-flex justify-content-between align-items-center ${item.bold ? 'fw-bold' : ''}`}
            >
              <div>
                {item.label}{' '}
                {item.percentage != null && (
                  <span className="fw-bold">
                    <Percentage value={item.percentage} />
                  </span>
                )}
              </div>
              <div>
                <Price negative={item.negative} value={item.amount} />
              </div>
            </div>

            {item.expandable && isExpanded && (
              <div className={'mt-2'}>
                {item.children?.map((child, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between ps-3 py-1 small text-muted"
                  >
                    <div>{child.label}</div>
                    <div>
                      <Price negative={item.negative} value={child.amount} />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {item.subtitle && (
              <div className="small text-muted ps-0 mb-2">
                {item.subtitle}
              </div>
            )}
            {item.borderBottom && <hr className="my-3" />}
          </React.Fragment>
        );
      })}

      {/* Szybkie płatności */}
      {toPay.some((payment) => payment.show) && (
        <div className="mt-5">
          <h6 className="fw-bold mb-3">Szybkie płatności</h6>

          {toPay.map((payment, index) => {
            if (!payment.show) {
              return null;
            }

            return (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center mb-3"
              >
                <div className="flex-grow-1">
                  {payment.label && <div>{payment.label}</div>}
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Price value={payment.amount} />
                  <LightButton show={true} onClick={payment.onPay} size="sm">
                    Zapłać
                  </LightButton>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
